import { useEffect } from 'react';

const NEAR_END_THRESHOLD_PX = 20;

type UseIntersectionObserverProps = {
    intersectionRootElement: HTMLElement | null;
    intersectionTargetElement: HTMLElement | null;
    onIntersect: () => void;
    rootMargin?: string;
};

export const useIntersectionObserver = ({
    intersectionRootElement,
    intersectionTargetElement,
    onIntersect,
    rootMargin = `0px 0px ${NEAR_END_THRESHOLD_PX}px 0px`,
}: UseIntersectionObserverProps) => {
    useEffect(() => {
        if (!intersectionRootElement || !intersectionTargetElement) {
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                    onIntersect();
                }
            },
            {
                root: intersectionRootElement,
                rootMargin,
                threshold: 0,
            }
        );

        observer.observe(intersectionTargetElement);

        return () => {
            observer.disconnect();
        };
    }, [onIntersect, intersectionRootElement, intersectionTargetElement, rootMargin]);
};
